(function () {
  'use strict';

  function formatDuration(seconds) {
    const s = Math.max(0, Math.round(Number(seconds) || 0));
    const m = Math.floor(s / 60);
    const r = s % 60;
    return m + ':' + String(r).padStart(2, '0');
  }

  function computeRoR(points, windowSec) {
    if (!points || points.length < 2) return [];
    const out = [];
    for (let i = 0; i < points.length; i += 1) {
      const [t, bt] = points[i];
      let j = i;
      while (j > 0 && t - points[j - 1][0] < windowSec) j -= 1;
      if (j === i) {
        out.push([t, 0]);
        continue;
      }
      const [t0, bt0] = points[j];
      const dtMin = (t - t0) / 60;
      const ror = dtMin > 0 ? (bt - bt0) / dtMin : 0;
      out.push([t, Math.max(0, Math.round(ror * 10) / 10)]);
    }
    return out;
  }

  function buildPath(values, xScale, yScale) {
    return values.map(function (pt, idx) {
      const cmd = idx === 0 ? 'M' : 'L';
      return cmd + xScale(pt[0]).toFixed(2) + ' ' + yScale(pt[1]).toFixed(2);
    }).join(' ');
  }

  function renderRoastCurveChart(container, data) {
    if (!container || !data || !Array.isArray(data.bean_temp) || data.bean_temp.length < 2) return;

    const beanTemp = data.bean_temp.map(function (row) {
      return [Number(row[0]), Number(row[1])];
    }).filter(function (row) {
      return !Number.isNaN(row[0]) && !Number.isNaN(row[1]);
    });

    if (beanTemp.length < 2) return;

    const durationSec = Number(data.duration_sec) || beanTemp[beanTemp.length - 1][0];
    const chargeTemp = Number(data.charge_temp) || beanTemp[0][1];
    const dropTemp = Number(data.drop_temp) || beanTemp[beanTemp.length - 1][1];
    const rorPoints = Array.isArray(data.ror) && data.ror.length
      ? data.ror.map(function (row) { return [Number(row[0]), Number(row[1])]; })
      : computeRoR(beanTemp, 30);

    const temps = beanTemp.map(function (row) { return row[1]; });
    const minTemp = Math.floor((Math.min.apply(null, temps) - 20) / 25) * 25;
    const maxTemp = Math.ceil((Math.max.apply(null, temps) + 20) / 25) * 25;
    const maxRoR = Math.max.apply(null, rorPoints.map(function (row) { return row[1]; }).concat([20]));

    const width = 920;
    const height = 420;
    const pad = { top: 28, right: 56, bottom: 44, left: 56 };
    const plotW = width - pad.left - pad.right;
    const plotH = height - pad.top - pad.bottom;

    function xScale(t) {
      return pad.left + (t / durationSec) * plotW;
    }

    function yScaleTemp(temp) {
      return pad.top + plotH - ((temp - minTemp) / (maxTemp - minTemp)) * plotH;
    }

    function yScaleRoR(ror) {
      return pad.top + plotH - (ror / maxRoR) * plotH;
    }

    const gridY = [];
    for (let temp = minTemp; temp <= maxTemp; temp += 50) {
      gridY.push(
        '<line class="roast-curve__grid" x1="' + pad.left + '" y1="' + yScaleTemp(temp) + '" x2="' + (width - pad.right) + '" y2="' + yScaleTemp(temp) + '"></line>' +
        '<text class="roast-curve__axis-label roast-curve__axis-label--y" x="' + (pad.left - 10) + '" y="' + (yScaleTemp(temp) + 4) + '" text-anchor="end">' + temp + '</text>'
      );
    }

    const gridX = [];
    const tickCount = 6;
    for (let i = 0; i <= tickCount; i += 1) {
      const t = (durationSec / tickCount) * i;
      gridX.push(
        '<line class="roast-curve__grid roast-curve__grid--x" x1="' + xScale(t) + '" y1="' + pad.top + '" x2="' + xScale(t) + '" y2="' + (height - pad.bottom) + '"></line>' +
        '<text class="roast-curve__axis-label" x="' + xScale(t) + '" y="' + (height - 12) + '" text-anchor="middle">' + formatDuration(t) + '</text>'
      );
    }

    const rorPath = buildPath(rorPoints, xScale, yScaleRoR);
    const btPath = buildPath(beanTemp, xScale, yScaleTemp);
    const dropX = xScale(durationSec);
    const dropY = yScaleTemp(dropTemp);

    container.innerHTML =
      '<svg class="roast-curve__svg" viewBox="0 0 ' + width + ' ' + height + '" role="img" aria-label="Roast profile chart">' +
        '<title>Bean temperature and rate of rise over roast time</title>' +
        gridY.join('') +
        gridX.join('') +
        '<text class="roast-curve__axis-title" x="' + (pad.left - 36) + '" y="' + (pad.top + plotH / 2) + '" transform="rotate(-90 ' + (pad.left - 36) + ' ' + (pad.top + plotH / 2) + ')">Bean temp (°F)</text>' +
        '<text class="roast-curve__axis-title" x="' + (width - 18) + '" y="' + (pad.top + plotH / 2) + '" transform="rotate(90 ' + (width - 18) + ' ' + (pad.top + plotH / 2) + ')">RoR (°F/min)</text>' +
        '<path class="roast-curve__line roast-curve__line--ror" d="' + rorPath + '"></path>' +
        '<path class="roast-curve__line roast-curve__line--bt" d="' + btPath + '"></path>' +
        '<circle class="roast-curve__marker" cx="' + xScale(0) + '" cy="' + yScaleTemp(chargeTemp) + '" r="4"></circle>' +
        '<circle class="roast-curve__marker roast-curve__marker--drop" cx="' + dropX + '" cy="' + dropY + '" r="4"></circle>' +
        '<text class="roast-curve__callout" x="' + xScale(0) + '" y="' + (yScaleTemp(chargeTemp) - 10) + '" text-anchor="start">Charge ' + Math.round(chargeTemp) + '°</text>' +
        '<text class="roast-curve__callout" x="' + dropX + '" y="' + (dropY - 10) + '" text-anchor="end">Drop ' + Math.round(dropTemp) + '°</text>' +
      '</svg>' +
      '<div class="roast-curve__legend">' +
        '<span class="roast-curve__legend-item"><i class="roast-curve__swatch roast-curve__swatch--bt"></i>Bean temp</span>' +
        '<span class="roast-curve__legend-item"><i class="roast-curve__swatch roast-curve__swatch--ror"></i>Rate of rise</span>' +
        '<span class="roast-curve__legend-item roast-curve__legend-item--meta">' + formatDuration(durationSec) + ' total</span>' +
      '</div>';
  }

  window.renderRoastCurveChart = renderRoastCurveChart;
})();
